import { render, staticRenderFns } from "./AttributeMatchingList.vue?vue&type=template&id=c03f4878&"
import script from "./AttributeMatchingList.vue?vue&type=script&lang=js&"
export * from "./AttributeMatchingList.vue?vue&type=script&lang=js&"
import style0 from "./attribute-matching-list.scss?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports